import { UserTypeService } from '@/services/UserTypeService'
import { ConfigCatHelper } from './ConfigCatHelper'
import { getCookie } from './cookieUtils'

export enum AuthFlowMode {
	PILOT = 'pilot',
	LEGACY = 'legacy',
	FEATURE_FLAG = 'feature_flag'
}

export class AuthFlowHelper {
	/**
	 * Determines if the new auth flow should be enabled based on cookie and feature flag
	 * @returns true if new auth flow should be enabled
	 */
	static async isNewAuthFlowEnabled(): Promise<boolean> {
		const flowMode = this.getCurrentAuthFlowMode()

		switch (flowMode) {
			case AuthFlowMode.LEGACY:
				return false
			case AuthFlowMode.PILOT:
				return true
			case AuthFlowMode.FEATURE_FLAG:
			default:
				await UserTypeService.init()
				return await ConfigCatHelper.getIsNewAuthFlowEnabled(UserTypeService.getUserType())
		}
	}

	/**
	 * Gets the current auth flow mode based on cookie
	 * @returns AuthFlowMode enum value
	 */
	static getCurrentAuthFlowMode(): AuthFlowMode {
		const flowCookie = getCookie('ISOLVE_AUTH_FLOW')

		if (flowCookie === 'pilot') {
			return AuthFlowMode.PILOT
		} else if (flowCookie === 'legacy') {
			return AuthFlowMode.LEGACY
		}

		return AuthFlowMode.FEATURE_FLAG
	}
}
